import {animate, style, transition, trigger} from '@angular/animations';

export const fadeInOut = trigger('in', [

  transition(':enter', [
    style({opacity: 0, transform: 'scale(1.1)', height: 0, paddingTop: 0, paddingBottom: 0}),
    animate('200ms ease-out', style({opacity: 1, transform: 'scale(1)', height: '*', paddingTop: '*', paddingBottom: '*'}))
  ]),

  transition(':leave', [
    animate('200ms ease-out', style({opacity: 0, transform: 'scale(1.1)', height: 0, paddingTop: 0, paddingBottom: 0}))
  ])
]);
